module.exports = __webpack_public_path__ + "img/alex-book-closed-3.aa8dc064.png";